import { useMemo, useState } from 'react';

import { PdpProductSizeType, PopupViewType, usePopupView } from '@domains/pdp-common';

import { useSizeRecommendationService } from './useSizeRecommendationService';

export const useOthersSizeService = () => {
  const [infoOpen, setInfoOpen] = useState<boolean>(false);
  const { showPopup } = usePopupView();

  const { sizeRecommendation } = useSizeRecommendationService();

  const { recommendOptionValueList, recommendationType, userAccount } = sizeRecommendation || {};

  const myFigureText = useMemo(() => {
    const height = userAccount?.body?.height;
    const weight = userAccount?.body?.weight;
    const sizeText = userAccount?.body?.sizeText;

    return formatMyFigureText(height, weight, sizeText);
  }, [userAccount]);

  // 상위 2개 옵션만 노출
  const displayedOptions = useMemo(() => {
    return recommendOptionValueList?.slice(0, 2) || [];
  }, [recommendOptionValueList]);

  const handleInfoClick = () => {
    showPopup(PopupViewType.SIZE_INFO, () => {
      setInfoOpen(true);
    });
  };

  const closeTooltip = () => {
    setInfoOpen(false);
  };

  return {
    userAccount,
    myFigureText,
    handleInfoClick,
    recommendOptionValueList: displayedOptions,
    infoOpen,
    closeTooltip,
    isOptionType: recommendationType === PdpProductSizeType.OPTION,
  };
};

const formatMyFigureText = (height?: number, weight?: number, sizeText?: string | null) => {
  // sizeText가 있으면 그것만 사용 (이미 "166cm · 56kg" 형식으로 포맷되어 있음)
  if (sizeText) {
    return sizeText;
  }

  // sizeText가 없으면 height/weight를 조합
  return [height ? `${height}cm` : null, weight ? `${weight}kg` : null]
    .filter((text): text is string => !!text)
    .join(', ');
};
